export const textInputLight = {
  borderColor: 'primary/text',
  borderStyle: 'solid',
  color: 'primary/text',
  paddingLeft: 'm',
  paddingRight: 'm',
  inputTextStyle: {
    fontSize: 'm',
    color: 'primary/text',
  },
  placeholderPropsStyle: {
    color: 'grey/light',
    paddingLeft: 'm',
    paddingRight: 'm',
  },
  variants: {
    underline: {
      borderColor: 'grey/dark',
      borderBottomWidth: 1,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
    },
    primary: {
      borderColor: 'primary',
    },
    secondary: {
      borderColor: 'light',
    },
    rounded: {
      borderColor: 'grey/dark',
      borderWidth: 'xs',
      borderRadius: 'round',
    },
  },
};
